import React from "react"
import types from "prop-types"
import clsx from "clsx"
import { useSelector } from "react-redux"
import SvgSpriteIcon from "shared/SvgSpriteIcon"
import { IndicatorIcon } from "shared/icons"
import { conversationIsRead } from "reduxSlices/formSubmissionConversationsSlice"

const ConversationUnreadMessagesIndicator = ({ className = "", conversationId }) => {
  const read = useSelector(conversationIsRead(conversationId))

  if (read) return null

  return (
    <div aria-label="Conversation has unread messages" role="img" className={clsx(className, "relative flex items-center")}>
      <SvgSpriteIcon ariaHidden className="stroke-dark stroke-[1.4]" iconName="dialogue-bubble" width={22} height={22} />
      <IndicatorIcon ariaHidden className="absolute top-[2px] -right-[8px]" />
    </div>
  )
}

ConversationUnreadMessagesIndicator.propTypes = {
  className: types.string,
  conversationId: types.number.isRequired,
}

export default ConversationUnreadMessagesIndicator
